// extracted by mini-css-extract-plugin
export default {"footerNotes":"nmUa2xNOc77GXVvuDUeL"};